export default __webpack_public_path__ + "static/media/include_6@2x.75ee3a36.jpg";